module.exports = __webpack_public_path__ + "static/media/white-shirt-casual.f794959d.jpg";